function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.879 10.502L.211 5.833a.718.718 0 010-1.016l1.015-1.015a.718.718 0 011.016 0l3.145 3.145L12.123.211a.718.718 0 011.016 0l1.016 1.016a.718.718 0 010 1.016l-8.26 8.259a.718.718 0 01-1.016 0z",
  fill: "#4aa8f5"
});

function SvgListCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.364,
    height: 10.712
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC4zNjQiIGhlaWdodD0iMTAuNzEyIiB2aWV3Qm94PSIwIDAgMTQuMzY0IDEwLjcxMiI+PHBhdGggZD0iTTQuODc5LDc1LjYuMjExLDcwLjkzMWEuNzE4LjcxOCwwLDAsMSwwLTEuMDE2TDEuMjI2LDY4LjlhLjcxOC43MTgsMCwwLDEsMS4wMTYsMGwzLjE0NSwzLjE0NSw2LjczNi02LjczNmEuNzE4LjcxOCwwLDAsMSwxLjAxNiwwbDEuMDE2LDEuMDE2YS43MTguNzE4LDAsMCwxLDAsMS4wMTZMNS44OTUsNzUuNmEuNzE4LjcxOCwwLDAsMS0xLjAxNiwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtNjUuMDk4KSIgZmlsbD0iIzRhYThmNSIvPjwvc3ZnPg==";
export { SvgListCheckmark as ReactComponent };